<div class="block w-full relative"
  [ngStyle]="{ padding: linePadding, color: textColor }"
  [ngClass]="sectionRoundedClass"
  [style.background-color]="!separatedBackground ? backgroundColor : undefined"
>
  <div class="max-w-6xl mx-auto">
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>

  <div *ngIf="keySellingPoints?.length"
        class="grid gap-5 w-full mt-3 py-2"
        [ngClass]="{
          'grid-cols-[repeat(auto-fit,minmax(200px,1fr))]' : listLayout === 'horizontal',
          'grid-cols-1' : listLayout === 'vertical'
        }"
  >
    <div *ngFor="let kp of keySellingPoints"
         class="flex py-2 rounded-lg"
         [ngClass]="{
           'flex-row items-start': listLayout === 'vertical',
           'flex-row items-center': layout === 'horizontal' && listLayout === 'horizontal',
           'flex-col items-center': layout === 'vertical',
         }"
         [style.background-color]="separatedBackground ? backgroundColor : undefined">

      <div *ngIf="kp.icon" [ngClass]="{
             'mr-1 shrink-0': layout === 'horizontal',
             'mb-1'        : layout === 'vertical'
           }">
        <img class="object-contain"
             [ngStyle]="{ width: iconSizePx, height: iconSizePx }"
             [src]="kp.icon | assetPreview:'small':'webp'"
             [alt]="kp.icon.customFields?.altText || 'Key Selling Point Icon'">
      </div>

      <div class="flex flex-col"
           [ngClass]="{
             'ml-2': layout === 'horizontal',
             'mt-1': layout === 'vertical',
           }"
           [style.text-align]="textAlignment">

        <span [ngStyle]="{ 'font-size.px': kpTitleFontPx, 'font-weight' : 450 }"
          [innerHTML]="kp.title | safeHtml">
        </span>

        <span [ngStyle]="{ 'font-size.px': kpValueFontPx, 'font-weight' : 300 }"
          [innerHTML]="kp.value | safeHtml">
        </span>
      </div>
    </div>
  </div>
  </div>
</div>
